// K3Core status text colors.
export const CONSIGNMENT_TEXT_TONE_CLASS = {
	neutral: "text-[#6B7280]",
	pending: "text-[#1976F2]",
	warn: "text-[#B45309]",
	ok: "text-[#2BA84A]",
	cancelled: "text-[#E84C3D]",
	danger: "text-[#DC2626]",
} as const;

export type ConsignmentTone = keyof typeof CONSIGNMENT_TEXT_TONE_CLASS;

// Badge background and text.
export const CONSIGNMENT_SOFT_TONE_CLASS = {
	ok: "bg-[#ECFDF3] text-[#2BA84A]",
	warn: "bg-[#FFFBEB] text-[#B45309]",
	danger: "bg-[#FEF2F2] text-[#E84C3D]",
	neutral: "bg-[#F3F4F6] text-[#6B7280]",
	info: "bg-[#EFF6FF] text-[#1976F2]",
} as const;

// Kit Badge (variant="outline") tone classes.
export const CONSIGNMENT_PILL_CLASS = {
	ok: `border-transparent ${CONSIGNMENT_SOFT_TONE_CLASS.ok}`,
	warn: `border-transparent ${CONSIGNMENT_SOFT_TONE_CLASS.warn}`,
	danger: `border-transparent ${CONSIGNMENT_SOFT_TONE_CLASS.danger}`,
	neutral: `border-transparent ${CONSIGNMENT_SOFT_TONE_CLASS.neutral}`,
	info: `border-transparent ${CONSIGNMENT_SOFT_TONE_CLASS.info}`,
} as const;

export const CONSIGNMENT_ALERT_CLASS = {
	info: "flex items-start gap-2 rounded-md border border-[#BFDBFE] bg-[#EFF6FF] px-4 py-3 text-sm text-[#1E40AF]",
	warn: "flex items-start gap-2 rounded-md border border-[#FDE68A] bg-[#FFFBEB] px-4 py-3 text-sm text-[#92400E]",
	danger:
		"flex items-start gap-2 rounded-md border border-[#FECACA] bg-[#FEF2F2] px-4 py-3 text-sm text-[#B91C1C]",
	ok: "flex items-start gap-2 rounded-md border border-[#BBF7D0] bg-[#ECFDF3] px-4 py-3 text-sm text-[#166534]",
} as const;

export const CONSIGNMENT_EMPTY_VALUE = "-";
